<template>
    <div :class="{
        'wrapper__closed': true,
        'wrapper__closed--competition': (type === 'competition'),
        'wrapper__closed--vote': (type === 'vote'),
        'is-mac': isMac
    }">
        <div class="wrapper__container">
            <p v-html="dates[type]"></p>
        </div>
    </div>
</template>

<script>
    import CONFIG from '@/config';

  export default {

    name: 'Closed',

    props: ['type'],

    data() {

        return {
            dates: {
                competition: CONFIG.settings.closed.voteBetween,
                vote: CONFIG.settings.closed.winnerAnnounced
            },
            isMac: navigator.platform.toUpperCase().indexOf('MAC') >= 0
        };
    }
  }
</script>

<style scoped lang="scss">
     .wrapper__closed {
         background-image: url('/images/background.png');
        background-repeat: no-repeat;
        background-position: bottom;
        height: 100%;
        position: absolute;
        width: 100%;
        top: 0;
        left: 0;

        &--competition {

            .wrapper__container {
                background-image: url('/images/closed_competition.png');
                background-repeat: no-repeat;
                background-position: 50% 50%;
            }

            p {
                top: 442px;
                font-size: 22px;
                line-height: 22px;
            }
        }

        &--vote {

            .wrapper__container {
                background-image: url('/images/closed_vote.png');
            }

            p {
                top: 450px;
                font-size: 23px;
                line-height: 23px;
            }
        }

        .wrapper__container {
            position: absolute;
            top: 50%;
            left: 50%;
            transform: translate(-50%, -50%);
        }

        p {
            color: #FFFFFF;
            font-family: 'Bungee', cursive;
            text-align: center;
            width: 100%;
            position: absolute;
        }
    }
</style>
